$(document).ready(function () {
  $(".menu-drawer-container .header__icon--menu").click(function () {
    $("body").addClass("open_sidebar");
  });
  $(".close_menu").click(function () {
    $("body").removeClass("open_sidebar");
  });
  $(".header__icon--cart").click(function () {
    $("body").addClass("open_cart");
  });

  $(document).on("click", ".close_cart", function (e) {
    $("body").removeClass("open_cart");
  });

  $(document).click(function (e) {
    e.stopPropagation();
    var container = $(
      ".menu-drawer-container .header__icon--menu , .sidebar_menu , .header__icon--cart , .sidebar_cart , .filter_box .dropdown_custom > a, .filter_box .dropdown_content"
    );

    //check if the clicked area is dropDown or not
    if (container.has(e.target).length === 0) {
      $("body").removeClass("open_sidebar");
      $("body").removeClass("open_cart");
      $(".filter_box .dropdown_custom").removeClass("open");
      $(".filter_box .dropdown_custom .dropdown_content").slideUp();
    }
  });

  $(".accordion > .accordion_link > a > span").click(function () {
    if ($(this).closest(".accordion_link").hasClass("open")) {
      $(this)
        .closest(".accordion_link")
        .removeClass("open")
        .find("> .submenu")
        .slideUp();
    } else {
      $(this).closest('.accordion_link').siblings("li.open").find('.submenu').slideUp();
      $(this).closest('.accordion_link').siblings("li.open").removeClass("open");
      $(this)
        .closest(".accordion_link")
        .addClass("open")
        .find("> .submenu")
        .slideDown();
    }
    return false;
  });

  $(function () {
    var Accordion = function (el, multiple) {
      this.el = el || {};
      this.multiple = multiple || false;

      // Variables privadas
      var links = this.el.find(".link");
      // Evento
      links.on(
        "click",
        { el: this.el, multiple: this.multiple },
        this.dropdown
      );
    };

    Accordion.prototype.dropdown = function (e) {
      var $el = e.data.el;
      ($this = $(this)), ($next = $this.next());

      $next.slideToggle();
      $this.parent().toggleClass("open");

      if (!e.data.multiple) {
        $el.find(".submenu").not($next).slideUp().parent().removeClass("open");
      }
    };

    var accordion = new Accordion($("#accordion"), false);
  });

  $(document).on("click", ".quntity_box .js-qty__adjust", function () {
    val = parseInt($(this).parent().find("input").val());

    if ($(this).hasClass("js-qty__adjust--minus")) {
      val = val - 1;
    } else if ($(this).hasClass("js-qty__adjust--plus")) {
      val = val + 1;
    }

    if (val < 1) {
      val = 1;
    }

    $(this).parent().find("input").val(val);
  });

  if ($(".also_like_slider").length > 0) {
    $(".also_like_slider").slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 500,
      easing: "linear",
      swipe: true,
      swipeToSlide: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      prevArrow:
        '<div class="previous"><svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Homepage" transform="translate(-6.000000, -1700.000000)"><g id="Group-Copy-4" transform="translate(27.000000, 1721.000000) scale(-1, 1) translate(-27.000000, -1721.000000) translate(7.000000, 1701.000000)"><circle id="Oval" stroke="#000000" opacity="0.3" cx="20" cy="20" r="20"></circle><polyline id="Line" stroke="#8D2E52" stroke-linecap="square" stroke-linejoin="bevel" points="19 16 23 21 19 26"></polyline></g></g></g></svg></div>',
      nextArrow:
        '<div class="next"><svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Homepage" transform="translate(-1388.000000, -1700.000000)"><g id="Group" transform="translate(1389.000000, 1701.000000)"><circle id="Oval" stroke="#000000" opacity="0.3" cx="20" cy="20" r="20"></circle><polyline id="Line" stroke="#8D2E52" stroke-linecap="square" stroke-linejoin="bevel" points="19 16 23 21 19 26"></polyline></g></g></g></svg></div>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
          },
        },
        {
          breakpoint: 375,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    });
  }

  $(".product_box .product_items .product_details .product_intro").matchHeight({
    byRow: true,
  });
  $(".product_items .product_details .product_intro").matchHeight({
    byRow: true,
  });
  $(".product_items .product_details .product_vendor").matchHeight({
    byRow: true,
  });
  $(".collection").on("DOMSubtreeModified", function () {
    $(
      ".collection .boost-pfs-filter-products .card-information .card-information__text"
    ).matchHeight({
      byRow: true,
    });
  });

  $(".filter_box .dropdown_custom > a").click(function () {
    if ($(this).parents(".dropdown_custom").hasClass("open")) {
      $(this).parents(".dropdown_custom").removeClass("open");
      $(this).next().slideUp();
    } else {
      $(".filter_box .dropdown_custom").removeClass("open");
      $(".filter_box .dropdown_custom .dropdown_content").slideUp();
      $(this).parents(".dropdown_custom").toggleClass("open");
      $(this).next().slideToggle();
    }
    return false;
  });

  $(".filter_box-mb .dropdown_custom a").click(function () {
    $(this).parents(".dropdown_custom").addClass("open");
    $("body").addClass("filter_open");
  });

  $(".filter_box-mb .dropdown_custom .dropdown_content .close_filter").click(
    function () {
      $(this).parents(".dropdown_custom").removeClass("open");
      $("body").removeClass("filter_open");
    }
  );

  if ($(".product_slider_main").length > 0) {
    $(".product_slider_main").slick({
      dots: false,
      arrows: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: ".product_slider_nav",
      prevArrow:
        '<div class="previous"><svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Homepage" transform="translate(-6.000000, -1700.000000)"><g id="Group-Copy-4" transform="translate(27.000000, 1721.000000) scale(-1, 1) translate(-27.000000, -1721.000000) translate(7.000000, 1701.000000)"><circle id="Oval" stroke="#000000" opacity="0.3" cx="20" cy="20" r="20"></circle><polyline id="Line" stroke="#8D2E52" stroke-linecap="square" stroke-linejoin="bevel" points="19 16 23 21 19 26"></polyline></g></g></g></svg></div>',
      nextArrow:
        '<div class="next"><svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Homepage" transform="translate(-1388.000000, -1700.000000)"><g id="Group" transform="translate(1389.000000, 1701.000000)"><circle id="Oval" stroke="#000000" opacity="0.3" cx="20" cy="20" r="20"></circle><polyline id="Line" stroke="#8D2E52" stroke-linecap="square" stroke-linejoin="bevel" points="19 16 23 21 19 26"></polyline></g></g></g></svg></div>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            dots: true,
          },
        },
      ],
    });
  }
  if ($(".product_slider_nav").length > 0) {
    $(".product_slider_nav").slick({
      dots: false,
      arrows: true,
      infinite: false,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: ".product_slider_main",
      focusOnSelect: true,
      prevArrow:
        '<div class="previous"><svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.25" y="0.75" width="29.5" height="29.5" rx="14.75" stroke="black" stroke-opacity="0.5" stroke-width="0.5"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.7972 10.3952C17.0676 10.6655 17.0676 11.1039 16.7972 11.3742L12.6714 15.5001L16.7972 19.6259C17.0676 19.8963 17.0676 20.3346 16.7972 20.605C16.5269 20.8754 16.0885 20.8754 15.8182 20.605L11.2028 15.9896C10.9324 15.7192 10.9324 15.2809 11.2028 15.0105L15.8182 10.3952C16.0885 10.1248 16.5269 10.1248 16.7972 10.3952Z" fill="#8D2E52"/></svg></div>',
      nextArrow:
        '<div class="next"><svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="29.75" y="30.25" width="29.5" height="29.5" rx="14.75" transform="rotate(-180 29.75 30.25)" stroke="black" stroke-opacity="0.5" stroke-width="0.5"/><path fill-rule="evenodd" clip-rule="evenodd" d="M13.2028 20.6048C12.9324 20.3345 12.9324 19.8961 13.2028 19.6258L17.3286 15.4999L13.2028 11.3741C12.9324 11.1037 12.9324 10.6654 13.2028 10.395C13.4731 10.1246 13.9115 10.1246 14.1818 10.395L18.7972 15.0104C19.0676 15.2808 19.0676 15.7191 18.7972 15.9895L14.1818 20.6048C13.9115 20.8752 13.4731 20.8752 13.2028 20.6048Z" fill="#8D2E52"/></svg></div>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: false,
          },
        },
        {
          breakpoint: 375,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    });
  }

  $(".product_tabs ul.tabs li").click(function () {
    var tab_id = $(this).attr("href");

    $(".product_tabs ul.tabs li").removeClass("current");
    $(".product_tabs .tab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });

  if ($(".product-popup").length > 0) {
    $(window).scroll(function () {
      if ($(this).scrollTop() > 200) {
        $(".product-popup").fadeIn();
      } else {
        $(".product-popup").fadeOut();
      }
    });
  }

  function recommendation_slider() {
    if ($(".recommendation_slider").length > 0) {
      $(".recommendation_slider").flickity({
        prevNextButtons: true,
        wrapAround: false,
        pageDots: false,
        contain: true,
        cellAlign: "center",
        watchCSS: false,
        groupCells: true,
        imagesLoaded: true,
        selectedAttraction: 0.01,
        friction: 0.15,
      });
    }
  }
  recommendation_slider();

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector(
              "product-recommendations"
            );
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              recommendation_slider();
              $(".product_items .product_details .product_intro").matchHeight({
                byRow: true,
              });
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 200px 0px",
      }).observe(this);
    }
  }

  customElements.define("product-recommendations", ProductRecommendations);
});

$(document).ready(function (e) {
  if ($("#product-form-installment").length > 0) {
    $(document).on(
      "change",
      `input[type="radio"],input[type="select"]`,
      function (e) {
        window.setTimeout(function (e) {
          let price = $(".product__info-container .price-item").html();
          //$(".product_action .price-item").html(price);
          if (
            typeof $(".product-form .product-form__buttons button").attr(
              "disabled"
            ) == "undefined"
          ) {
            $(".product_action .btn-custom-yellow").removeAttr("disabled");
            //$(".product_action .btn-custom-yellow").text($(".product-form .product-form__buttons button").text());
            $(".btn-custom-yellow").removeClass("disabled");
          } else {
            $(".product_action .btn-custom-yellow").attr(
              "disabled",
              "disabled"
            );
            //$(".product_action .btn-custom-yellow").text($(".product-form .product-form__buttons button").text());
            $(".btn-custom-yellow").addClass("disabled");
            $(".btn-custom-yellow").attr("disabled", "true");
          }
        }, 600);
      }
    );
  }

  $(document).on(
    "change",
    `[data-within-collection].product-form__input input`,
    function (e) {
      let parent = $(e.target).parents("form.shopify-product-form");
      let variant_id = $(parent)
        .find(`[data-within-collection] input:checked`)
        .val();
      let price = $(parent)
        .find(`[data-within-collection] input:checked`)
        .attr("data-price");
      let compare_at_price = $(parent)
        .find(`[data-within-collection] input:checked`)
        .attr("data-compare_at_price");
      let available = $(parent)
        .find(`[data-within-collection] input:checked`)
        .attr("data-available");
      $(parent).find(`.price-item.price-item--regular`).html(price);
      $(parent).find(`.price-item.price-item--sale`).html(compare_at_price);
      $(parent)
        .find(`a.btn-custom[data-var-id]`)
        .attr("data-var-id", variant_id);
      if (available == "true") {
        $(parent)
          .find(`a.btn-custom[data-var-id]`)
          .removeClass("disabled")
          .text("Add to Cart");
      } else {
        $(parent)
          .find(`a.btn-custom[data-var-id]`)
          .addClass("disabled")
          .text("Sold Out");
      }
    }
  );

  $(document).on("click", ".open_link_atc", function () {
    if ($(this).parents(".room_wrapper").hasClass("is-open")) {
      $(this)
        .parents(".room_wrapper")
        .removeClass("is-open")
        .find(".collection_links")
        .slideUp();
    } else {
      $(".room_wrapper.is-open .collection_links").slideUp();
      $(".room_wrapper.is-open").removeClass("is-open");
      $(this)
        .parents(".room_wrapper")
        .addClass("is-open")
        .find(".collection_links")
        .slideDown();
    }
    return false;
  });

  $(document).on("click", ".btn-collection-close", function () {
    $(this).parents(".room_wrapper").removeClass("is-open");
    $(this).parents(".collection_links").slideUp();
  });
  
});

// 16-03-22
if(typeof $.fn.matchHeight !== 'undefined') {
  $(
    ".collection_products .product_box .items .product_items .product_details .product_intro .product_title"
  ).matchHeight({
    byRow: true,
  });
}

$(document).ready(function (e) {
  $('.shopify-section.spaced-section [class=""]').addClass("container");

  /* Best Seller Sections */
  let listOfEvents = Array();
  listOfEvents.push("shopify:inspector:activate");
  listOfEvents.push("shopify:inspector:deactivate");
  listOfEvents.push("shopify:section:load");
  listOfEvents.push("shopify:section:unload");
  listOfEvents.push("shopify:section:select");
  listOfEvents.push("shopify:section:deselect");
  listOfEvents.push("shopify:section:reorder");
  listOfEvents.push("shopify:block:select");
  listOfEvents.push("shopify:block:deselect");

  let reinitBestSellersFunction = () => {
    $(".best_seller_slider").each((ix, em) => {
      let sectionID = $(em).parents(".best_seller_section").attr("id");
      if ($(`#${sectionID} .best_seller_slider`).length > 0) {
        if (
          $(`#${sectionID} .best_seller_slider.flickity-enabled`).length > 0
        ) {
          $(`#${sectionID} .best_seller_slider.flickity-enabled`).flickity(
            "destroy"
          );
        }
        $(`#${sectionID} .best_seller_slider`).flickity({
          prevNextButtons: true,
          wrapAround: false,
          pageDots: false,
          contain: true,
          cellAlign: "center",
          watchCSS: false,
          groupCells: true,
          imagesLoaded: true,
          selectedAttraction: 0.01,
          friction: 0.15,
        });
      }
    });
  };
  listOfEvents.forEach((em, ix) => {
    $(document).on(`${em}`, () => {
      reinitBestSellersFunction();
    });
  });
  reinitBestSellersFunction();
});

// mega menu toggle position relative 
$(document).ready(function (e) {
  const listItem = document.querySelector('.header__megaMenuItem');

  listItem.addEventListener('mouseover', function() {
    listItem.closest('.list-menu').style.position = 'unset';
  });
  listItem.addEventListener('mouseout', function() {
    listItem.closest('.list-menu').style.position = 'relative';
  })
})

/* mobile shop menu image */
$(document).ready(function(){
  if($('.js-sidebar-extra-link').length > 0) {
    $('.js-sidebar-extra-link').attr("href",$('.js-mobile-menu-data').attr("data-href"));
    $('.js-sidebar-extra-img').attr("src", $('.js-mobile-menu-data').attr("data-src"));
  }
})